<template>
  <div class="page_socialInsurance">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <template v-if="activeName2=='0'">
              <el-form-item label="导入批次号" size="small">
                <el-input v-model="listQuery.importBatchNumber" size="small" clearable style="width:180px"></el-input>
              </el-form-item>
              <el-form-item label="开始时间" size="small">
                <el-date-picker v-model="listQuery.startTime" type="date" value-format="yyyy-MM-dd" placeholder="" size="small" style="width:180px"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" size="small">
                <el-date-picker v-model="listQuery.endTime" type="date" value-format="yyyy-MM-dd" placeholder="" size="small" style="width:180px"></el-date-picker>
              </el-form-item>
            </template>
            <template v-if="activeName2=='1'">
              <el-form-item label="账单月" size="small">
                <el-date-picker v-model="listQuery.billingMonth" type="month" value-format="yyyy-MM" placeholder="" size="small" style="width:180px"></el-date-picker>
              </el-form-item>
              <el-form-item label="账户类型" size="small">
                <el-select v-model="listQuery.accountType" placeholder="" filterable clearable size="small" style="width: 180px;">
                  <el-option value="自有账户"></el-option>
                  <el-option value="供应商代参"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="参保账户" size="small">
                <el-input v-model="listQuery.insuredAccountFullName" size="small" clearable style="width:180px"></el-input>
              </el-form-item>
            </template>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <el-form-item label="导入人" size="small" v-if="activeName2=='0'">
            <el-input v-model="listQuery.importer" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <template v-if="activeName2=='1'">
            <el-form-item label="供应商" size="small">
              <el-input v-model="listQuery.insuredAccountFullName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="参保省市区:" prop="serveProvince">
              <el-cascader :props="propsAddress" filterable ref="cascaderArr" clearable v-model="address" :options="areaList" @change="changeAreaHandle" size="small" style="width: 180px;"></el-cascader>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.project" placeholder="" clearable filterable size="small" style="width:180px">
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>社保</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <socialTab ref="child"></socialTab>
        <el-tabs v-model="activeName2" @tab-click="changeTab2">
          <el-tab-pane label="批次" name="0"></el-tab-pane>
          <el-tab-pane label="导入明细" name="1"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="importBill" v-if="checkPermission(['importBill_import'], this.permissionLists)">账单导入</el-button>
          <el-button type="primary" size="small" @click="expList" v-if="checkPermission(['importBill_export'], this.permissionLists)" :loading="isExping">导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" v-if="activeName2==0">
          <el-table-column prop="importBatchNumber" key="1" label="导入批次号" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="socialSecurityPersonnelCount" key="2" label="社保人员数量" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="publicFundPersonnelCount" key="3" label="公积金人员数量" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="socialSecurityPublicFundAmount" key="4" label="社保公积金金额" min-width="120" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="otherExpenses" key="5" label="其他费用" min-width="80" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="serviceFee" key="6" label="服务费" min-width="80" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="totalAmount" key="7" label="合计金额" min-width="80" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="importer" key="8" label="导入人" min-width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="createTime" key="9" label="导入时间" min-width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">{{ scope.row.createTime ? scope.row.createTime.replace('T', ' ') : '' }}</template>
          </el-table-column>
          <el-table-column prop="allCount" label="总数量" align="center" min-width="90" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="successCount" label="实名成功数量" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="errorCount" label="实名失败数量" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" align="center" min-width="100" fixed="right">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" @click="getDtl(row)">明细</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="del(row)" style="margin-left:10px;" v-if="row.createUserId == userId || roletype.indexOf('admin') != -1">
                  <el-button type="text" v-preventReClick slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <tableDtl v-if="activeName2==1" v-loading="loading" :tableData="tableData"></tableDtl>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="导入账单" :visible.sync="showImport" width="500px">
      <el-form :model="impForm" ref="impForm" label-width="80px">
        <el-form-item label="导入模板:" prop="phoneNum">
          <el-button type="text" class="blueName cp" @click="downImportTemp">下载模板</el-button>
        </el-form-item>
        <el-form-item label="导入账单:" prop="fileUrl">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入账单</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="beforeImport" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入账单确认" :visible.sync="showError" width="500px">
      <div class="errTips">以下账单已存在，请确认是否覆盖，或追加？</div>
      <el-table :data="errorList" border class="doc_table" style="width:100%">
        <el-table-column prop="name" label="账户" min-width="300" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="errorMsg" label="账单月" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="confirmImport(true)" :loading="isBtnLoading">覆盖</el-button>
        <el-button type="primary" size="small" @click="confirmImport(false)" :loading="isBtnLoading">追加</el-button>
      </span>
    </el-dialog>

    <el-dialog title="错误提示" :visible.sync="showError2" width="1000px">
      <el-table :data="errorList" border style="width: 100%" max-height="600px">
        <el-table-column prop="id" label="行号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="350" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="errorMsg" label="错误信息" min-width="500" align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="showError2 = false">关 闭</el-button>
      </span>
    </el-dialog>

    <div class="dialogBox">
      <el-dialog title="明细" :visible.sync="showDtl" width="1100px">
        <tableDtl v-loading="loading" :tableData="dtlData"></tableDtl>
        <div class="block">
          <el-pagination v-if="totalCount2>0" @current-change="currentChange2" :current-page.sync="dtlQuery.pageNum" :page-size="Number(dtlQuery.pageSize)" @size-change="handleSizeChange2" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount2"></el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="showDtl = false">关 闭</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="showPolling" width="500px" :close-on-press-escape="false" :show-close="false">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">实名认证查询中，预计耗时1~5分钟，请耐心等待.....</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import tableDtl from "./components/tableDtl.vue"
  import socialTab from "./components/socialTab.vue"
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    components: {
      tableDtl,
      socialTab
    },
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          importBatchNumber: '',
          importMan: '',
          startTime: "",
          endTime: "",
          importer: '',
          founder: Cookies.get("userid-b")
        },
        showDropScreen: -1,
        activeName: '账单导入',
        num1: 0,
        tableData: [],
        customerList: [],
        roletype: localStorage.loginRoletype,
        permissionLists: [],
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        activeName2: '0',
        isExping: false,
        showImport: false,
        showError: false,
        isBtnLoading: false,
        fileList: [],
        errorList: [],
        userId: Cookies.get("userid-b"),
        impForm: {
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          isCover: false
        },
        showDtl: false,
        dtlData: [],
        dtlQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 0
            }]
          },
          id: '',
          founder: Cookies.get("userid-b")
        },
        totalCount2: 0,
        showError2: false,
        showPolling: false,
        importId: '',
        times: 0,
        address: [],
        areaList: [], //省市区列表
        propsAddress: {
          label: 'Name',
          value: 'Name',
          children: 'children',
        },
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      this.getButtonPower();
      this.getList();
      this.getMemberList();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/socialBill',
          powerEnName: 'socialBill'
        }
        xz.getbtnPowerIdBypage(d).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then(res => {
          this.areaList = res;
        })
      },
      // 获取人员列表
      getMemberList() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      changeAreaHandle(val) {
        if (val.length == 3) {
          this.listQuery.insuredProvince = val[0]
          this.listQuery.insuredCity = val[1]
          this.listQuery.insuredDistrict = val[2]
        } else {
          this.listQuery.insuredProvince = '';
          this.listQuery.insuredCity = '';
          this.listQuery.insuredDistrict = '';
        }
      },
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        let pagename = this.activeName2 == '0' ? 'GetSocialSecurityBatchPageList' : 'GetImportSocialSecurityBatchDetailPageList';
        this.loading = true;
        xz.SocialFun(this.listQuery, pagename, 'post').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '垫资成本') {
          this.$router.push({
            path: '/advCost'
          })
        }
      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: "createTime",
                order: 1
              }]
            },
            importBatchNumber: '',
            importMan: '',
            startTime: "",
            endTime: ""
          }
        } else {
          if (this.areaList.length == 0) {
            this.getprovinces();
            this.getProList();
          }
          this.tableData = [];
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: "createTime",
                order: 0
              }]
            },
            id: '',
            billingMonth: '',
            accountType: '',
            insuredAccountFullName: '',
            supplierFullName: '',
            insuredProvince: '',
            insuredCity: '',
            insuredDistrict: '',
            project: '',
            name: '',
            employeePhone: '',
            idCardNumber: '',
            formOwner: '',
            affiliatedCompany: '',
            invoicingCompany: ''
          }
        }
        this.getList();
      },
      importBill() {
        this.impForm = {
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          isCover: false
        }
        this.fileList = [];
        this.isBtnLoading = false;
        this.showImport = true;
      },
      downImportTemp() {
        var path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20250429093812515.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.setAttribute('download', '导入账单模板.xlsx');
        aTag.click();
      },
      // 上传结算单附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.impForm.fileUrl = res;
          } else {
            this.impForm.fileUrl = '';
          }
        });
      },
      handleExceed() {
        this.$message.warning(`当前限制最多导入 1 个文件`);
      },
      // 删除结算单附件
      handleFileRemove() {
        this.impForm.fileUrl = '';
      },
      beforeImport() {
        if (this.impForm.fileUrl == '') {
          this.$message.error('请上传文件');
        } else {
          this.isBtnLoading = true;
          let d = {
            fileUrl: this.impForm.fileUrl,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          xz.SocialFun(d, 'CheckSocialSecurityBatch', 'post').then(res => {
            if (res.status == 'ok') {
              if (res.data.error.length > 0) { //返回error 弹窗  覆盖/不覆盖
                this.errorList = res.data.error;
                this.isBtnLoading = false;
                this.showError = true;
              } else {
                this.confirmImport(false)
              }
              // this.getList();
              // this.isBtnLoading = false;
              // this.showAddAccount = false;
              // this.$message.success('保存成功');
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      confirmImport(val) {
        this.isBtnLoading = true;
        this.impForm.isCover = val;
        xz.SocialFun(this.impForm, 'ImportSocialSecurityBatch', 'post').then(res => {
          if (res.status == 'ok') {
            if (res.data.error != undefined && res.data.error.length > 0) {
              this.errorList = res.data.error;
              this.showError2 = true;
            } else {
              this.$message.success('保存成功');
              this.showPolling = true;
              this.times = 0;
              if (res.data != undefined && res.data.id != undefined) {
                this.importId = res.data.id;
                this.polling();
              }
            }
            this.getList();
            this.isBtnLoading = false;
            this.showImport = false;
            this.showError = false;
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      polling() {
        let d = {
          id: this.importId,
          userId: Cookies.get("userid-b"),
        }
        xz.SocialFun(d, 'CardIdverify', 'post').then(res => {
          if (res.status == 'ok') {
            if (res.data.status != undefined && res.data.status != 1 && this.times < 40) {
              setTimeout(() => {
                this.times++;
                console.log(this.times)
                this.polling()
              }, this.times < 10 ? 1000 : 10000);
            } else {
              this.showPolling = false;
            }
          }
        })
      },
      //明细
      getDtl(row) {
        this.dtlQuery.id = row.id;
        this.getDtlList();
        this.showDtl = true;
      },
      //获取明细列表
      getDtlList() {
        this.loading = true;
        xz.SocialFun(this.dtlQuery, 'GetImportSocialSecurityBatchDetailPageList', 'post').then(res => {
          if (res.status == 'ok') {
            this.dtlData = res.data.data;
            this.totalCount2 = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.dtlData = [];
            this.totalCount2 = 0;
            this.loading = false;
          }
        })
      },
      currentChange2(val) {
        this.dtlQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.dtlQuery.PageModel.Page = 1;
        this.dtlQuery.PageModel.Rows = val;
        this.getList();
      },
      del(row) {
        let d = {
          id: [row.id],
          userId: Cookies.get("userid-b")
        }
        this.loading = true;
        xz.SocialFun(d, 'DeleteSecurityBatch', 'post').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.loading = false;
            this.$message.success('保存成功');
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      //金额格式化
      formatAmount(row, column, cellValue) {
        return cellValue ? parseFloat(cellValue).toFixed(2) : '';
      },
      expList() {
        this.isExping = true;
        let pagename = this.activeName == '0' ? 'ExportSocialSecurityBatchPageList' : 'ExportImportSocialSecurityBatchDetailPageList/download';
        let d = JSON.parse(JSON.stringify(this.listQuery));
        delete d.PageModel;
        d.filename = `${this.activeName}列表.xlsx`;
        xz.SocialExpFun(d, pagename).then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = `${this.activeName}列表.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .record {
    margin-top: 10px;
    color: #797979;
  }

  .checkedgroup {
    display: flex;
    /* flex-flow: wrap; */
  }

  .pro_down_box {
    padding-left: 29px;
  }

  .errTips {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .Checking {
    display: flex;
    justify-content: center;
  }

  .CheckingTips {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
    padding-bottom: 30px;
  }
</style>
<style>
  .page_socialInsurance .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_socialInsurance .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_socialInsurance .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_socialInsurance .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_socialInsurance .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_socialInsurance .el-checkbox__label {
    padding-left: 3px;
  }

  .page_socialInsurance .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .page_socialInsurance .dialogBox .el-dialog__body {
    padding: 20px 20px 5px 20px;
  }

  .el-tooltip__popper {
    max-width: 800px;
  }
</style>